// @flow

import React from 'react';
import { components } from '@peachjar/components';

import {
  APOLLO_QUERY_INITIAL_LOAD,
  MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL,
} from '../../../constants';

const { Buttons, LoadingIndicators } = components;

const { ButtonPrimaryLarge } = Buttons;
const { Spinner } = LoadingIndicators;

const styles = {
  buttonWrapper: {
    display: 'flex',
    marginLeft: '-5px',
    marginTop: '2rem',
  },
};

export const doesNotPassFormRequirements = (
  touched,
  errors,
  orgNotFound,
  loading,
  isSoloSchoolInLargerDistrict,
  didEnterSchoolIdInsteadOfDistrictId,
  didEnterDistrictIdInsteadOfSchoolId,
  didExceedAllowedSchoolVariance,
  isSubmitting,
  eligibility,
  numberOfSchoolsInt,
  isCharterSchool,
  isCharterSchoolProceeding
) => {
  const inRfpFlow =
    numberOfSchoolsInt > MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL;

  const areThereErrors = inRfpFlow
    ? Object.keys(errors).length >= 1
    : Object.keys(errors).length > 1;

  // if school is signing up solo in larger district, fail UNLESS it's a charter school
  const doesFailCharterSchoolCheck = isCharterSchool
    ? isCharterSchoolProceeding !== true
    : isSoloSchoolInLargerDistrict;

  return (
    Object.keys(touched).length < 1 ||
    areThereErrors ||
    orgNotFound ||
    !!loading ||
    doesFailCharterSchoolCheck ||
    didEnterSchoolIdInsteadOfDistrictId ||
    didEnterDistrictIdInsteadOfSchoolId ||
    didExceedAllowedSchoolVariance ||
    isSubmitting ||
    eligibility.isEligible === false
  );
};

const SchoolRegistrationButton = ({
  buttonText,
  touched,
  errors,
  orgNotFound,
  loading,
  isSoloSchoolInLargerDistrict,
  didEnterSchoolIdInsteadOfDistrictId,
  didEnterDistrictIdInsteadOfSchoolId,
  didExceedAllowedSchoolVariance,
  isSubmitting,
  eligibility,
  numberOfSchoolsInt,
  isCharterSchool,
  isCharterSchoolProceeding,
  onclick,
  networkStatus,
}) => (
  <div style={styles.buttonWrapper}>
    <ButtonPrimaryLarge
      type="submit"
      data-testid="submit-registrationInfo"
      disabled={doesNotPassFormRequirements(
        touched,
        errors,
        orgNotFound,
        loading,
        isSoloSchoolInLargerDistrict,
        didEnterSchoolIdInsteadOfDistrictId,
        didEnterDistrictIdInsteadOfSchoolId,
        didExceedAllowedSchoolVariance,
        isSubmitting,
        eligibility,
        numberOfSchoolsInt,
        isCharterSchool,
        isCharterSchoolProceeding
      )}
      onClick={onclick}
    >
      {loading && networkStatus !== APOLLO_QUERY_INITIAL_LOAD && <Spinner />}

      {buttonText}
    </ButtonPrimaryLarge>
  </div>
);

export default SchoolRegistrationButton;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/SchoolRegistration/components/SchoolRegistrationButton.jsx